import { Component, Input, OnInit } from '@angular/core';
import { PageSize } from '../../../core/dto/page.size';
import * as _ from 'lodash';
import { SETTINGS } from '../../../core/config/common.settings';
import { AccidentRecordService } from '../../../core/services/accident-record.service';
import { Pagination } from '../../../core/dto/pagination';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-view-accidents',
  templateUrl: './view-accidents.component.html',
  styleUrls: ['./view-accidents.component.scss'],
})
export class ViewAccidentsComponent implements OnInit {
  @Input() fleetData: any | undefined;
  accidentsData: any[] = [];
  isDeleting = false;

  pageSize = new PageSize();
  sortField: any;
  sortOrder: any = -1;

  bookingReferenceFilter: any;
  dateFilter: any;
  startTime: any;
  endTime: any;
  searchText: any;
  placeFilter: any;

  skeletonTableColumns: any[] = [
    'Accident No.',
    'Accident Date and Time',
    'Filled by',
    'Booking Reference',
    'Reason',
    'Driver Name',
    'Place',
    'Insurance follow up status',
    'Created Date',
    'Actions',
  ];
  loading = false;

  constructor(
    private accidentService: AccidentRecordService,
    private messages: NzMessageService,
    private router: Router,
  ) {}

  ngOnInit(): void {}

  onTableParamsChange(params: NzTableQueryParams): void {
    this.pageSize.pageSize = params.pageSize;
    this.pageSize.pageIndex = params.pageIndex;
    this.getPagedAccidents();
  }

  getPagedAccidents(): void {
    this.loading = true;
    const payload = Object.assign({}, new Pagination(this.pageSize), {
      sortField: this.sortField,
      sortOrder: this.sortOrder,
      filters: {
        fleet: this.fleetData._id,
        bookingReference: this.bookingReferenceFilter,
        searchText: this.searchText,
        place: this.placeFilter,
        startTime: this.startTime,
        endTime: this.endTime,
        // role: this.filterRole,
        // searchText: this.searchText,
        // status: this.filterStatus,
      },
    });
    this.accidentService.getPagedAccidentRecord(payload).subscribe(
      (res: any) => {
        this.loading = false;
        this.accidentsData = res[0].data;
        this.pageSize.length = res[0].metadata[0]?.total;
      },
      (e: any) => {
        this.loading = false;
        this.messages.create('error', 'Error');
      },
    );
  }

  sort(): void {
    this.sortOrder = this.sortOrder === 1 ? -1 : 1;
    this.getPagedAccidents();
  }

  viewAccidentRecord(id: string): void {
    this.router.navigate([
      `/admin/fleets/${this.fleetData?.id}/accidents/${id}`,
    ]);
  }

  search(): void {
    // this.startTime = moment(this.dateFilter).startOf('day').format();
    // this.endTime = moment(this.dateFilter).endOf('day').format();
    // console.log('role', this.filterRole);
    // console.log('text', this.searchText);
    // console.log('status', this.filterStatus);
    this.getPagedAccidents();
  }

  searchDate(): void {
    this.startTime = moment(this.dateFilter[0]).startOf('day').format();
    this.endTime = moment(this.dateFilter[1]).endOf('day').format();
    this.getPagedAccidents();
  }

  resetSearch(): void {
    this.startTime = null;
    this.endTime = null;
    this.dateFilter = null;
    this.placeFilter = null;
    this.searchText = null;
    this.bookingReferenceFilter = null;
    // this.searchText = null;
    // this.filterRole = null;
    // this.filterStatus = null;
    this.getPagedAccidents();
  }

  changeStatus(id: any, status: boolean): void {
    this.accidentService
      .getPagedAccidentRecord({ _id: id, active: !status })
      .subscribe(
        (res) => {
          this.getPagedAccidents();
        },
        (e: any) => {
          this.messages.create('error', 'Error');
        },
      );
  }

  hasAccessToPerformAction(): boolean {
    return (
      _.includes(
        localStorage.getItem(SETTINGS.USER_PERMISSIONS),
        'USER_UPDATE',
      ) ||
      _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), 'USER_DELETE')
    );
  }

  hasPermission(perm: string): boolean {
    return _.includes(localStorage.getItem(SETTINGS.USER_PERMISSIONS), perm);
  }

  async softDeleteConfirm(id: any): Promise<void> {
    this.isDeleting = true;
    this.accidentService.softDeleteAccidentRecord(id).subscribe(
      (res: any) => {
        this.isDeleting = false;
        this.messages.create(
          'success',
          'Accident record has been deleted successfully',
        );
        this.getPagedAccidents();
      },
      (e: any) => {
        this.isDeleting = false;
        this.messages.create('error', 'Error');
      },
    );
  }

  cancel(): void {}
}
